import { render, staticRenderFns } from "./declare.vue?vue&type=template&id=2a498744&scoped=true&"
import script from "./declare.vue?vue&type=script&lang=js&"
export * from "./declare.vue?vue&type=script&lang=js&"
import style0 from "./declare.vue?vue&type=style&index=0&id=2a498744&prod&lang=scss&scoped=true&"
import style1 from "./declare.vue?vue&type=style&index=1&id=2a498744&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a498744",
  null
  
)

export default component.exports